var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastResponse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#FFFFFF00;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29,20.041c0,1.695-1.373,3.078-3.078,3.078h-4.649l-2.424,2.453c-0.426,0.436-1.136,0.436-1.562,0   l-2.424-2.453h-4.649c-1.693,0-3.078-1.385-3.078-3.078V9.18c0-1.704,1.383-3.078,3.078-3.078h15.71C27.622,6.102,29,7.48,29,9.18   V20.041z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M14.655,14.613c0-0.715-0.58-1.295-1.295-1.295c-0.715,0-1.295,0.58-1.295,1.295s0.58,1.295,1.295,1.295   C14.076,15.908,14.655,15.328,14.655,14.613z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.359,14.613c0-0.715-0.58-1.295-1.295-1.295c-0.715,0-1.295,0.58-1.295,1.295s0.58,1.295,1.295,1.295   C18.779,15.908,19.359,15.328,19.359,14.613z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 22.768,
    cy: 14.613,
    r: 1.295
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M25.92,5.199H10.21c-1.357,0-2.646,0.719-3.364,1.876c-0.262,0.422-0.132,0.978,0.29,1.239   c0.421,0.263,0.978,0.132,1.239-0.29C8.768,7.393,9.471,7,10.21,7h15.71c1.202,0,2.18,0.978,2.18,2.18v10.86   c0,1.202-0.978,2.18-2.18,2.18h-4.65c-0.24,0-0.472,0.097-0.641,0.268l-2.423,2.454c-0.052,0.053-0.155,0.057-0.141,0.059   c-0.035,0-0.085-0.01-0.137-0.063l-2.43-2.45c-0.169-0.17-0.398-0.267-0.639-0.267h-4.65c-0.743,0-1.431-0.383-1.841-1.024   c-0.268-0.419-0.826-0.541-1.243-0.274c-0.419,0.269-0.542,0.824-0.274,1.243c0.743,1.162,1.998,1.856,3.358,1.856h4.275   l2.154,2.172c0.371,0.389,0.874,0.604,1.415,0.607c0.004,0,0.008,0,0.012,0c0.533,0,1.054-0.219,1.424-0.597l2.155-2.183h4.274   c2.194,0,3.98-1.786,3.98-3.98V9.18C29.9,6.985,28.114,5.199,25.92,5.199z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.459,17.678c0-0.497-0.403-0.9-0.9-0.9H5.052c-0.497,0-0.9,0.403-0.9,0.9s0.403,0.9,0.9,0.9h3.507   C9.056,18.578,9.459,18.175,9.459,17.678z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.459,14.613c0-0.497-0.403-0.9-0.9-0.9H4.025c-0.497,0-0.9,0.403-0.9,0.9s0.403,0.9,0.9,0.9h4.533   C9.056,15.514,9.459,15.11,9.459,14.613z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.459,11.55c0-0.497-0.403-0.9-0.9-0.9H3c-0.497,0-0.9,0.403-0.9,0.9s0.403,0.9,0.9,0.9h5.559   C9.056,12.45,9.459,12.047,9.459,11.55z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastResponse);
export default __webpack_public_path__ + "static/media/fast-response.b8c88da4b394cd8137a381865128983d.svg";
export { ForwardRef as ReactComponent };